class Cookie {

    /**
     * Constructor
     */
    constructor() {
        document.getElementById('allow-cookie').addEventListener('click', () => Cookie.userAllowCookie());
        document.getElementById('refuse-cookie').addEventListener('click', () => Cookie.userRefuseCookie());
    }

    /**
     * User allow cookie
     */
    static userAllowCookie() {
        Cookie.set('read_cookie', 1, 365);
        Cookie.set('allow_cookie', 1, 365);
        Cookie.closeBanner();
    }

    /**
     * User refuse cookie
     */
    static userRefuseCookie() {
        Cookie.set('read_cookie', 1, 1);
        Cookie.closeBanner();
    }

    /**
     * Set cookie
     * @param cookieName
     * @param cookieValue
     * @param expirationDays
     */
    static set(cookieName, cookieValue, expirationDays) {
        let d = new Date();
        d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        let expires     = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    };

    /**
     * Get cookie by name
     * @param cookieName
     * @return {string}
     */
    static get(cookieName) {
        let name          = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca            = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };

    /**
     * Close cookie banner
     */
    static closeBanner() {
        document.getElementById('banner-cookie').classList.add('hide-banner');
    }

}